import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ProjectTemplateConvertIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ProjectTemplateConvertIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ProjectTemplateConvertIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ProjectTemplateConvertIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ProjectTemplateConvertIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M20 4a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2v-8h2v8h14V6h-8V4h8zM8 1a2 2 0 012 2v5a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h5zm8.37 10.121l-1.906 1.93L17 15.585 15.586 17l-2.536-2.536-1.929 1.907v-5.25h5.25zM8 3v5H3V3h5z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ProjectTemplateConvertIcon.displayName = "ProjectTemplateConvertIcon";
export default ProjectTemplateConvertIcon;
